<template>
    <div>
        <b-container class="container-fluid mt-3 mt-md-5">
            <b-row class="p-0 m-0">
                <b-col col sm="12" class="p-0 m-0">
                    <b-card no-body class="p-0 m-0">
                        <div class="card shadow px-2 m-0">
                            <div class="card-header bg-transparent p-0 m-0">
                                    <h3 class="float-left mb-0 m-3">
                                        {{ $t('message.medicalAdvice') }}
                                    </h3>
                                    <div class="medical-advice-header float-right mr-5">
                                        <b-dropdown
                                            dropdown
                                            text="action"
                                            variant="primary"
                                            class="mt-2"
                                            size="sm"
                                            v-if="
                                                (adviceResponse && isReceiver(medicalAdvice) && !hasCurrentUserResponded(medicalAdvice))
                                                || !!medicalAdvice.creer_lien
                                                || isEmitter(medicalAdvice)
                                            ">
                                            <b-dropdown-item
                                                    href="#"
                                                    v-if="adviceResponse && isReceiver(medicalAdvice) && !hasCurrentUserResponded(medicalAdvice)"
                                                    @click="onResponseToMedicalAdvice()"
                                            >
                                                {{ $t('message.response') }}
                                            </b-dropdown-item>

                                            <b-dropdown-item
                                                    href="#"
                                                    v-if="!!medicalAdvice.creer_lien"
                                                    @click="onGoToMedicalFileClick()"
                                            >
                                                {{ $t('message.medicaleFolder') }}
                                            </b-dropdown-item>

                                            <b-dropdown-item
                                                    href="#"
                                                    v-if="isEmitter(medicalAdvice)"
                                                    @click="onEditClick()"
                                            >
                                                {{ $t('message.edit') }}
                                            </b-dropdown-item>

                                            <b-dropdown-item
                                                    href="#"
                                                    v-if="isEmitter(medicalAdvice)"
                                                    @click="showDeleteModal()"
                                            >
                                                {{ $t('message.delete') }}
                                            </b-dropdown-item>
                                        </b-dropdown>

                                        <b-badge
                                                :variant="getVariantCodeEmergency(medicalAdvice.code_urgence)"
                                                class="ml-2">
                                            {{ $t(getCodeName(medicalAdvice.code_urgence)) }}
                                        </b-badge>
                                    </div>

                                <div class="card-body m-0 m-md-3 p-0 p-md-3">
                                    <div class="card-title ml-3">
                                    </div>
                                    <b-container fluid>
                                        <section>
                                            <div class="medical-advice-content">
                                                <div class="box-content">
                                                    <br>
                                                    <div class="box-item">
                                                        <br>

                                                        <div class="medial-advice-item-box">
                                                            <p class="medial-advice-item-box-label">
                                                                {{ $t('message.nomPatient') }}:
                                                            </p>
                                                            <p class="medial-advice-item-box-content">
                                                               {{medicalAdvice.dossier.patient.user.nom + ' ' + medicalAdvice.dossier.patient.user.prenom}}
                                                            </p>
                                                        </div>

                                                        <div class="medial-advice-item-box">
                                                            <p class="medial-advice-item-box-label">
                                                                {{ $t('message.doctorName') }}:
                                                            </p>
                                                            <p class="medial-advice-item-box-content">
                                                                {{ displayDoctor(medicalAdvice.medecin_avis) }}
                                                            </p>
                                                        </div>

                                                        <div class="medial-advice-item-box">
                                                            <p class="medial-advice-item-box-label">
                                                                {{ $t('message.objectAdvice') }}:
                                                            </p>
                                                            <p class="medial-advice-item-box-content">
                                                                {{ medicalAdvice.objet }}
                                                            </p>
                                                        </div>

                                                        <div class="medial-advice-item-box">
                                                            <p class="medial-advice-item-box-label">
                                                                {{ $t('message.description') }}:
                                                            </p>
                                                            <p
                                                                class="medial-advice-item-box-content"
                                                                v-html="medicalAdvice.description"
                                                            >
                                                                {{ medicalAdvice.description }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="medical-advice-footer">

                                            </div>
                                        </section>

                                        <div v-if="anyResponse" class="timeline">
                                            <div class="timeline-month">
                                                {{ $t('message.doctorsResponse') }}
                                            </div>
                                            <div v-for="(adviceDoctorGroup, key) in adviceDoctors" :key="key">
                                                <div
                                                    v-if="adviceDoctorGroup[0].avis"
                                                    class="timeline-section"
                                                >
                                                    <div class="timeline-date">
                                                        {{ displayDate(adviceDoctorGroup[0].set_opinion_at) }}
                                                    </div>
                                                    <div class="row">
                                                        <div
                                                                v-for="(adviceDoctor, keyG) in adviceDoctorGroup" :key="keyG"
                                                                class="col-sm-6"
                                                        >
                                                            <div class="timeline-box">
                                                                <div class="box-title">
                                                                    <i
                                                                        v-if="adviceDoctor.statut === 'VALIDE'"
                                                                        class="fa fa-check text-success"
                                                                        aria-hidden="true"></i>
                                                                    <b-badge
                                                                            v-if="keyG !== adviceDoctorGroup.length - 1"
                                                                            variant="warning"
                                                                            class="mr-2"
                                                                    >
                                                                        {{ $t('message.edited') }}
                                                                    </b-badge>
                                                                    {{adviceDoctor.medecin.nom + ' ' + adviceDoctor.medecin.prenom}}

                                                                </div>
                                                                <div class="box-content">
                                                                    <div class="box-item primary-color">
                                                                        <p v-html="adviceDoctor.avis">
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="box-footer">
                                                                    <b-button
                                                                            variant="primary"
                                                                            size="sm"
                                                                            class="mb-2"
                                                                            v-if="isReceiver(medicalAdvice) &&
                                                                             adviceDoctor.medecin_id === user.id &&
                                                                             adviceDoctor.statut !== 'VALIDE' &&
                                                                             keyG === 0"
                                                                            @click="onEditResponseToMedicalAdvice(adviceDoctor.slug)"
                                                                    >
                                                                        <i class="fa fa-reply"></i>
                                                                        {{ $t('message.edit') }}
                                                                    </b-button>

<!--                                                                    v-if="isEmitter(medicalAdvice) && adviceDoctor.statut !== 'VALIDE'"-->
                                                                    <b-button
                                                                            variant="primary"
                                                                            size="sm"
                                                                            class="mb-2"
                                                                            v-if="isEmitter(medicalAdvice) &&
                                                                            adviceDoctor.statut !== 'VALIDE' &&
                                                                            keyG === 0"
                                                                            @click="setDoctorAdviceAsValidated(adviceDoctor)"
                                                                    >
                                                                        <i class="fa fa-check"></i>
                                                                        {{ $t('message.validateResponse') }}
                                                                    </b-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <p v-else class="mt-2">
                                            <i>{{ $t('message.noResponseForTheMoment') }}</i>
                                        </p>

                                        <section>
                                            <b-modal
                                                    size="sm"
                                                    id="delete-medicalAdvice"
                                                    header-bg-variant="danger"
                                                    header-text-variant="light"
                                                    :title="$t('message.delete') + ' ' + $t('message.medicalAdvice')"
                                                    hide-footer
                                            >
                                                <div class="d-block text-center">
                                                    <h3>{{ $t('message.deleteConfirmation') }}</h3>
                                                </div>

                                                <div class="d-block float-right">
                                                    <b-button variant="danger" @click="$bvModal.hide('delete-medicalAdvice')">
                                                        {{ $t('message.cancel') }}
                                                    </b-button>

                                                    <b-button variant="secondary" @click="handleDeleteMedicalAdvice">
                                                        {{ $t('message.delete') }}
                                                    </b-button>
                                                </div>
                                            </b-modal>
                                        </section>
                                    </b-container>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
	import * as _ from "lodash";
	import moment from 'moment';
	import {mapGetters} from "vuex";
	import router from '../../router/router';

    export default {
        name: "ShowMedicalAdvice",

        computed: {
            ...mapGetters([
				"practitioners",
				"controlDoctors",
                "patients",
                "medicalAdvice",
                "adviceResponse",
                "hasAssistante"
            ]),

			mPatients: function() {
				let pArray = [];

				_.forEach(this.patients, function(patient) {
					if (typeof patient.user == 'object' && patient.user.isMedicasure){
						let user = patient.user;
						if (typeof patient.dossier == "object"){
							let dossier  = patient.dossier;
							let prenom = (user.prenom != null && user.prenom) ?  user.prenom : '' ;
							prenom =  prenom.toLowerCase();
							let text = (user.nom).toUpperCase()+" "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
							pArray.push({text: text, value: patient.dossier.id });
						}
					}
				});

				return pArray;
			},

			mPractitioners: function() {
				let pArray = [];

				_.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
					let p = {};
					// if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) && practitioner.user.isMedicasure == '1'){
					if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) && practitioner.user.isMedicasure){
						// console.log('practitioner.user.isMedicasure => ', practitioner.user.isMedicasure);
						let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
						prenom =  prenom.toLowerCase();
						p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
						p.id = practitioner.user.id;
						if (p.nom.length >0){
							pArray.push(p);
						}
					}

				});

				return pArray;
			},

			mDoctors: function() {
				let dArray = [];

				_.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
					let d = {};
					// if((typeof doctor.user == 'object') && (!_.isNull(doctor.user)) && doctor.user.isMedicasure == '1'){
					if((typeof doctor.user == 'object') && (!_.isNull(doctor.user)) && doctor.user.isMedicasure){
						let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
						prenom =  prenom.toLowerCase();
						d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
						d.id = doctor.user.id;

						if (d.nom.length >0){
							dArray.push(d);
						}
					}

				});

				return dArray;
			},

			mContributors:function () {
				let cArray = [];
				return cArray.concat(this.mDoctors,this.mPractitioners);
			}
        },

        data() {
            return {
				offset: 0,
				limit: -1,
				user: JSON.parse(localStorage.getItem('user')),
				anyResponse: false,
				adviceDoctors: null,
				medicalAdviceSlug: this.$route.params.medicalAdviceSlug,
            };
        },
        watch: {
			adviceResponse: function (newAdviceResponse, o) {
				// console.log('newAdviceResponse => ', newAdviceResponse);
				if (newAdviceResponse.view !== undefined && !Boolean(Number(newAdviceResponse.view))) {
					this.markMedicalAdviceAsViewed();
				}
			},
			medicalAdvice: function (newMedicalAdvice, o) {
				// console.log('newMedicalAdvice => ', newMedicalAdvice);
				// console.log('user => ', this.user);
				this.anyResponse = newMedicalAdvice.medecin_avis.filter(m => m.avis).length > 0;
				this.adviceDoctors = Object.values(_.groupBy(newMedicalAdvice.medecin_avis, 'medecin_id')).map(adviceDoctorGroup => {
					return adviceDoctorGroup.sort((a,b) => moment(b.created_at).format('x') - moment(a.created_at).format('x'))
                });
				// console.log('adviceDoctors => ', this.adviceDoctors);
			},
        },
        methods: {
			isEmitter(avis) {
				return avis.creator === this.user.id;
			},

			isReceiver(avis) {
				return avis.medecin_avis.filter(m => m.medecin_id === this.user.id).length > 0;
			},

            hasCurrentUserResponded(avis) {
				return !!avis.medecin_avis.find(m => m.medecin_id === this.user.id).avis;
            },

			displayDoctor(doctors) {
                let distinctDoctors =  _.map(_.uniqBy(doctors, 'medecin_id'), function (item) {
                    return item;
                });

				return distinctDoctors.map(doctor =>{
                    if(typeof doctor.medecin == 'object' && doctor.medecin != null){
                        return doctor.medecin.nom + ' ' + doctor.medecin.prenom
                    }
                }).join(', ');
			},

            displayDate(date) {
				return moment(date).format("dddd, MMMM Do YYYY, h:mm:ss a");
            },

			getCreateLinkStatus(shouldCreateLink, isClass = false) {
				return !!shouldCreateLink
					? !isClass ? 'message.boundToPatientMedicalFolder' : '--success'
					: !isClass ? 'message.notBoundToPatientMedicalFolder' : '--warning';
			},

			onResponseToMedicalAdvice() {
				router.push({
                    name: 'response-medical-advice',
                    params: {
                    	medicalAdviceSlug: this.medicalAdviceSlug,
                    }
				});
			},

			onEditResponseToMedicalAdvice(doctorAdviceSlug) {
				router.push({
					name: 'edit-response-medical-advice',
					params: {
						doctorAdviceSlug: doctorAdviceSlug,
						medicalAdviceSlug: this.medicalAdviceSlug,
					}
				});
			},

			onGoToMedicalFileClick() {
				// router.push({ name: 'medical-file', params: {file: this.medicalAdvice.dossier.slug} });
				router.push( (router.resolve({ name: 'medical-file', params: {file: this.medicalAdvice.dossier.slug} })).href + '#generale');
			},

			onEditClick() {
				event.preventDefault();
				router.push({ name: 'edit-medical-advice', params: {medicalAdviceSlug: this.medicalAdviceSlug} });
			},

			showDeleteModal() {
				event.preventDefault();
				this.$bvModal.show('delete-medicalAdvice');
			},

			handleDeleteMedicalAdvice() {
				event.preventDefault();

				const successMessage = this.$i18n.t('message.medicalAdviceDeleted');
				const errorMessages = {
					generic: this.$i18n.t('message.genericError'),
					error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
				};

				const payload = { args: {}, slug: this.medicalAdviceSlug, errorMessages, successMessage };

				this.$store.dispatch('deleteMedicalAdvice', payload).then(() => {
					router.push({ name: 'medical-advice', params: {} });
				});
			},

			getAdviceResponse() {
				const args = {
					adviceSlug: this.medicalAdviceSlug
				};
				const errorMessages = {
					generic: this.$i18n.t('message.genericError'),
					error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
				};

				this.$store.dispatch('getAdviceResponse', { args, errorMessages });
			},

            markMedicalAdviceAsViewed() {
				const args = {
					avis: this.adviceResponse.avis,
					status: this.adviceResponse.status,
				    view: '1'
                };

				const errorMessages = {
					generic: this.$i18n.t('message.genericError'),
					error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
				};

				const actionToPerform = 'updateDoctorAdvice';

				const payload = {
					args,
					adviceResponseSlug: this.adviceResponse.slug,
					shouldRedirect: false,
					shouldSentNotification: false,
                    errorMessages,
				};

				this.$store.dispatch(actionToPerform, payload).then(() => {
					this.getAdviceResponse();
				});
            },

			setDoctorAdviceAsValidated(doctorAdvice) {
				const args = {
					avis: doctorAdvice.avis,
					statut: 'VALIDE',
					view: '1',
				};

				const errorMessages = {
					generic: this.$i18n.t('message.genericError'),
					error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
				};

				const actionToPerform = 'updateDoctorAdvice';

				const payload = {
					args,
					adviceResponseSlug: doctorAdvice.slug,
					shouldRedirect: true,
					shouldSentNotification: true,
					errorMessages,
				};

				this.$store.dispatch(actionToPerform, payload).then(() => {
					this.getAdviceResponse();
				});
			},

			getMedicalAdvice() {
				const args = {
					avis: this.medicalAdviceSlug
				};
				const errorMessages = {
					generic: this.$i18n.t('message.genericError'),
					error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
				};

				this.$store.dispatch('getMedicalAdvice', { args, errorMessages });
			},

			getPatients: function() {
				this.$store.dispatch('getPatients', { args: {} });
			},

			getDoctors() {
				let args = {
					offset: this.offset,
					limit: this.limit
				};

				this.$store.dispatch('getControlDoctors', { args : args });
			},

			getPractitioners() {
				let args = {
					offset: this.offset,
					limit: this.limit
				};

				this.$store.dispatch('getPractitioners', { args : args });
			},

			errorshasField(field) {
				return this.errors ? this.errors.hasOwnProperty(field) : false;
			},

			clearErrorField(field) {
				this.$store.dispatch('clearErrorField', {field});

				this.errorshasField(field);
			},

			getVariantCodeEmergency(emergencyCode) {
				if (emergencyCode.toLowerCase() === 'normal') {
					return 'primary';
				}
				else if (emergencyCode.toLowerCase() === 'urgent') {
					return 'warning';
				}
				else return 'danger';
			},

			getCodeName(emergencyCode) {
				if (emergencyCode.toLowerCase() === 'normal') {
					return 'message.normal';
				}
				else if (emergencyCode.toLowerCase() === 'urgent') {
					return 'message.urgent';
				}
				else return 'message.ultraUrgent';
			},
        },
        mounted() {
            this.getMedicalAdvice();

            this.getAdviceResponse();

            this.getPatients();

			// Fetch control doctor list
			this.getDoctors();

			// Fetch practitioner list
			this.getPractitioners();
        }
    }
</script>





<style scoped lang="scss">
    
</style>
